import React, { useState, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { useMediaQuery } from 'react-responsive'
import { useLocation } from 'react-router-dom'
import { useSelector } from "react-redux";
import axios from 'axios';
import NavbarMob from '../components/NavbarMob'
import Navbar from '../components/Navbar'
import FooterMob from '../components/FooterMob'
import Footer from '../components/Footer'
import filter from '../images/Products/filter.png'
import product1 from '../images/Home/product2.webp'
import heart from '../images/Home/heart.png'
import filledHeart from '../images/Home/heart2.png';
// import cart from '../images/Home/cart.png'
import forward from '../images/Products/forwardpng.png'
import top from '../images/Products/top.png'
import Filter from '../components/Filter'
import { useStore } from '../useStore';

const PromotionTags = ({ product }) => {
    return (
        <div className="flex flex-wrap gap-1 mb-1">
            {product.BestSeller === 1 && (
                <span className="bg-orange-100 text-orange-600 text-[9px] font-bold px-1.5 py-0.5 rounded-full uppercase tracking-wider">
                    Best Seller
                </span>
            )}
            {product.LimitedSale === 1 && (
                <span className="bg-rose-100 text-rose-600 text-[9px] font-bold px-1.5 py-0.5 rounded-full uppercase tracking-wider">
                    Limited Sale
                </span>
            )}
            {product.NewArrivals === 1 && (
                <span className="bg-sky-100 text-sky-600 text-[9px] font-bold px-1.5 py-0.5 rounded-full uppercase tracking-wider">
                    New Arrival
                </span>
            )}
        </div>
    );
};


function SubCatProducts() {
    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
    const isTab = useMediaQuery({ query: '(max-width: 1024px)' });

    const navigate = useNavigate();
    const home = () => {
        navigate('/')
    }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const userId = useSelector((state) => state.user.id);
    //('Logged in User ID:', userId);

    const [minPrice, setMinPrice] = useState(0); // Minimum price (UI only)
    const [maxPrice, setMaxPrice] = useState(2000); // Maximum price (UI only)
    const [priceFilterApplied, setPriceFilterApplied] = useState(false); // Only send price params when user applies
    const [showFilter, setShowFilter] = useState(false);
    const [isPriceExpanded, setPriceExpanded] = useState(true);
    const [isColorsExpanded, setIsColorsExpanded] = useState(true);
    const [isSizeExpanded, setIsSizeExpanded] = useState(true);
    const [isDressExpanded, setIsDressExpanded] = useState(true);
    const [showFilterMob, setShowFilterMob] = useState(false);
    const location = useLocation();

    // Retrieve params from state OR query parameters (for refresh/direct link support)
    const queryParams = new URLSearchParams(location.search);
    const c = queryParams.get('c');
    const n = queryParams.get('n');

    // Decode base64 parameters if they exist in the URL
    const decodedId = c ? atob(c) : null;
    const decodedName = n ? atob(n) : null;

    const categoryId = location.state?.categoryId || decodedId || queryParams.get('categoryId');
    const categoryName = (location.state?.categoryName || decodedName || queryParams.get('categoryName'))?.toUpperCase();

    const [targetProductCount] = useState(100);
    const [loginId, setLoginId] = useState(null);
    const [offerPrices, setOfferPrices] = useState({});


    const { showDropdown, setShowDropdown } = useStore()
    // const [loading, setLoading] = useState(true)
    //("ID", categoryId);

    useEffect(() => {
        // Get userId from localStorage
        const storedLoginId = localStorage.getItem('loginId');
        setLoginId(storedLoginId);
    }, []);


    const [products, setProducts] = useState([]);
    const [visibleProducts, setVisibleProducts] = useState([]);
    const [wishlistItems, setWishlistItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [hasLoadedOnce, setHasLoadedOnce] = useState(false);

    // Pagination states
    const [nextRowOffset, setNextRowOffset] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const [totalProducts, setTotalProducts] = useState(0);
    const [currentApiUrl, setCurrentApiUrl] = useState('');
    const PAGE_SIZE = 20;

    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const apiLocalUrl = process.env.REACT_APP_API_LOCAL_URL;

    // Refs for caching and mounting
    const imageCacheRef = useRef(new Map());
    const mountedRef = React.useRef(true);
    const abortControllerRef = React.useRef(null);

    useEffect(() => {
        mountedRef.current = true;
        return () => {
            mountedRef.current = false;
        };
    }, []);

    // Optimized: Check multiple images at once (from Home page)
    const checkImagesBatch = async (imageCodes) => {
        if (!imageCodes.length) return {};
        const batchSize = 30;
        const results = {};

        for (let i = 0; i < imageCodes.length; i += batchSize) {
            const batch = imageCodes.slice(i, i + batchSize);
            const batchPromises = batch.map(async (code) => {
                if (imageCacheRef.current.has(code)) {
                    return { code, exists: imageCacheRef.current.get(code) };
                }

                try {
                    const res = await fetch(
                        `${apiLocalUrl}/check-image/${encodeURIComponent(code)}`
                    );

                    if (!res.ok) {
                        imageCacheRef.current.set(code, false);
                        return { code, exists: false };
                    }

                    const data = await res.json();
                    imageCacheRef.current.set(code, data.exists);
                    return { code, exists: data.exists };

                } catch (err) {
                    imageCacheRef.current.set(code, false);
                    return { code, exists: false };
                }
            });

            const batchResults = await Promise.all(batchPromises);
            batchResults.forEach(result => {
                results[result.code] = result.exists;
            });
        }

        return results;
    };

    // Optimized: Get available color for a product (from Home page)
    const getAvailableColorForProduct = async (productId) => {
        try {
            const response = await axios.get(`${apiBaseUrl}/getProductDetails/BLACKBATON_2526?Id=${productId}`);
            if (response.status === 200) {
                const data = response.data;
                const distinctColorsArr = [...new Set(
                    data.filter(item => item.ItemId === productId).map(item => item.Color?.trim()).filter(Boolean)
                )];

                const colorCodes = distinctColorsArr.map(color => `${productId}_${color}.webp`);
                const colorResults = await checkImagesBatch(colorCodes);

                for (const color of distinctColorsArr) {
                    const code = `${productId}_${color}.webp`;
                    if (colorResults[code]) {
                        return color;
                    }
                }
                return null;
            }
        } catch (error) {
            console.error('Error:', error);
            return null;
        }
    };

    // Optimized: Check if image exists for a product (from Home page)
    const checkImageExists = async (product) => {
        try {
            const imageCodesToCheck = [];

            if (product.displayFirst) {
                const displayFirstCode = `${product.displayFirst}.webp`;
                imageCodesToCheck.push(displayFirstCode);
            }

            const imageResults = await checkImagesBatch(imageCodesToCheck);

            if (product.displayFirst) {
                const displayFirstCode = `${product.displayFirst}.webp`;
                if (imageResults[displayFirstCode]) {
                    return { exists: true, code: displayFirstCode, color: null };
                }
            }

            const color = await getAvailableColorForProduct(product.ID);
            if (color) {
                const colorCode = `${product.ID}_${color}.webp`;
                return { exists: true, code: colorCode, color };
            }

            return { exists: false, code: null, color: null };
        } catch (error) {
            console.error('Error checking image:', error);
            return { exists: false, code: null, color: null };
        }
    };

    // Optimized: Process products in batches (from Home page)
    const processProductsBatch = async (productsList, isLoadMore = false, batchSize = 20) => {
        const validProducts = [];

        for (let i = 0; i < productsList.length && validProducts.length < targetProductCount; i += batchSize) {
            const batch = productsList.slice(i, i + batchSize);

            const batchPromises = batch.map(async (product) => {
                if (!product) return null;
                
                // If backend already validated
                if (product.hasValidImage) {
                    return product;
                }

                try {
                    const imageCheck = await checkImageExists(product);
                    if (imageCheck.exists) {
                        return {
                            ...product,
                            displayFirst: imageCheck.code?.replace('.webp', '') || product.displayFirst
                        };
                    }
                } catch (err) {
                    console.error('Error checking product', product?.ID, err);
                }
                return null;
            });

            const batchResults = await Promise.all(batchPromises);
            const validBatchProducts = batchResults.filter(Boolean);

            validProducts.push(...validBatchProducts);

            // Update UI with new products immediately
            if (mountedRef.current && validBatchProducts.length > 0) {
                setProducts(prev => {
                    const combined = isLoadMore ? [...prev] : [];
                    const newProducts = validBatchProducts.filter(newProd =>
                        !combined.some(p => p.ID === newProd.ID)
                    );
                    return [...combined, ...newProducts];
                });

                if (mountedRef.current) {
                    setVisibleProducts(prev => {
                        const base = isLoadMore ? [...prev] : [];
                        const newIds = validBatchProducts
                            .map(p => p.ID)
                            .filter(id => !base.includes(id));
                        return [...base, ...newIds];
                    });
                }
            }

            if (i + batchSize < productsList.length && validProducts.length < targetProductCount) {
                await new Promise(resolve => setTimeout(resolve, 0));
            }
        }

        return validProducts;
    };

    // Unified fetch logic for subcategories and special flags (logic from SearchPage/Products)
    const fetchProductsWithAvailability = async (isLoadMore = false) => {
        if (!apiBaseUrl) return;

        if (!isLoadMore) {
            // Cancel previous request if any
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
            const controller = new AbortController();
            abortControllerRef.current = controller;
            const signal = controller.signal;

            setLoading(true);
            setProducts([]); // Clear products to ensure skeleton displays
            setVisibleProducts([]);
            setNextRowOffset(0);
            setHasMore(true);
            setHasLoadedOnce(false); // Reset loaded flag for new category
        } else {
            setIsLoadingMore(true);
        }

        const params = new URLSearchParams();
        if (priceFilterApplied) {
            params.append('minPrice', minPrice);
            params.append('maxPrice', maxPrice);
        }
        // Note: SubCatProducts doesn't seem to have selectedColor/selectedSize states in original code
        // but adding placeholders for consistency if they are added later
        // if (selectedColor) params.append('color', selectedColor);
        // if (selectedSize) params.append('size', selectedSize);

        let baseUrl;
        // Normalize the category name to detect special flags regardless of spacing/casing/plurals
        const normalizedCategory = (categoryName || '').replace(/\s+/g, '').toUpperCase();
        const isSpecialCategory = ['NEWARRIVAL', 'NEWARRIVALS', 'BESTSELLER', 'BESTSELLERS', 'LIMITEDSALE', 'LIMITEDSALES'].includes(normalizedCategory);

        if (isSpecialCategory) {
            let option;
            if (normalizedCategory.startsWith('NEWARRIVAL')) option = 'NewArrivals';
            else if (normalizedCategory.startsWith('BESTSELLER')) option = 'BestSeller';
            else if (normalizedCategory.startsWith('LIMITEDSALE')) option = 'LimitedSale';

            // Send both type and Id to satisfy the backend's flexible parameter handling
            const specialParams = `${params.toString()}&type=${option}&Id=${option}`;
            baseUrl = `${apiBaseUrl}/getNewArrival_BestSeller_LimitedSale/BLACKBATON_2526?${specialParams}`;
        } else {
            // If it's not a special category, we require a categoryId
            if (!categoryId) {
                if (mountedRef.current && !isLoadMore) {
                    setLoading(false);
                }
                return;
            }
            baseUrl = `${apiBaseUrl}/getProductBySubCategory/BLACKBATON_2526?Id=${categoryId}&${params.toString()}`;
        }

        setCurrentApiUrl(baseUrl);

        const currentOffset = isLoadMore ? nextRowOffset : 0;
        try {
            const signal = abortControllerRef.current?.signal;
            const response = await axios.get(`${baseUrl}&nextRowOffset=${currentOffset}&pageSize=${PAGE_SIZE}`, {
                signal: signal
            });
            const result = response.data;

            if (result.products && Array.isArray(result.products)) {
                const rawProducts = result.products;

                // Process in batches with image strategy
                await processProductsBatch(rawProducts, isLoadMore, 20);

                setNextRowOffset(result.pagination?.nextRowOffset || 0);
                setHasMore(result.pagination?.hasMore || false);
                setTotalProducts(result.pagination?.totalProducts || 0);

                setHasLoadedOnce(true);
            } else {
                setHasLoadedOnce(true); // Also set if we got a valid but empty/non-array result
            }
        } catch (error) {
            if (axios.isCancel(error)) {
                // console.log('Request cancelled:', error.message);
                return;
            }
            console.error('Error fetching products:', error);
        } finally {
            if (mountedRef.current) {
                // Only unset loading if this request wasn't aborted
                if (isLoadMore || (abortControllerRef.current && !abortControllerRef.current.signal.aborted)) {
                    setLoading(false);
                    setIsLoadingMore(false);
                }
            }
        }
    };

    useEffect(() => {
        setPriceFilterApplied(false); // reset price filter on category change
        fetchProductsWithAvailability();
        return () => {
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
        };
    }, [apiBaseUrl, categoryId, categoryName]);

    const loadMoreProducts = () => {
        if (hasMore && !isLoadingMore) {
            fetchProductsWithAvailability(true);
        }
    };

    // Infinite Scroll - REMOVED
    // useEffect(() => {
    //     const handleScroll = () => {
    //         if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 1000) {
    //             loadMoreProducts();
    //         }
    //     };
    //     // ...
    // }, []);


    const handleMinChange = (e) => {
        const value = Math.min(Number(e.target.value), maxPrice - 10); // Ensure min < max
        setMinPrice(value);
    };

    const handleMaxChange = (e) => {
        const value = Math.max(Number(e.target.value), minPrice + 10); // Ensure max > min
        setMaxPrice(value);
    };


    const addToWishlist = async (product) => {
        const apiUrl = `${apiBaseUrl}/wishlist/add/BLACKBATON_2526`;

        const activeUserId = loginId || userId; // Use loginId if available, otherwise use userId

        if (!activeUserId) {
            console.error("No valid user ID found.");
            alert("User ID is missing.");
            return;
        }

        const payload = {
            ID: product.ID,
            ItemName: product.ItemName,
            MRP: product.MRP,
            ledcode: activeUserId,  // Use the determined user ID
            Qty: product.Qty
        };

        try {
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                const result = await response.json();
                //("Added to wishlist:", result);
                // Update the local state
                setWishlistItems(prevItems => [...prevItems, product]);
                alert("Item added to wishlist!");
            } else {
                console.error("Failed to add to wishlist");
                alert("Already in Wishlist");
            }
        } catch (error) {
            console.error("Error:", error);
            alert("An error occurred while adding to wishlist.");
        }
    };

    useEffect(() => {
        const fetchWishlistItems = async () => {
            try {
                const activeUserId = loginId || userId; // Use loginId if available, otherwise use userId

                if (!activeUserId) return; // Ensure there's a valid userId before making the API call

                const response = await fetch(`${apiBaseUrl}/wishlist/items/BLACKBATON_2526/${activeUserId}`);
                const data = await response.json();

                if (data.success) {
                    setWishlistItems(data.items);
                }
            } catch (error) {
                console.error("Error fetching wishlist items:", error);
            }
        };

        fetchWishlistItems();
    }, [loginId, apiBaseUrl, userId]);

    const removeFromWishlist = async (productId) => {
        try {
            const response = await fetch(`${apiBaseUrl}/wishlist/delete/BLACKBATON_2526/${productId}`, {
                method: 'DELETE',
            });

            if (response.ok) {
                // Update the local state
                setWishlistItems(prevItems => prevItems.filter(item => item.ID !== productId));
                alert('Item removed from wishlist!');
            } else {
                console.error('Failed to remove item from wishlist');
            }
        } catch (error) {
            console.error('Error:', error);
            alert('An error occurred while removing from wishlist.');
        }
    };

    // useEffect(() => {
    //     const fetchOfferPrices = async () => {
    //         const prices = {};
    //         for (const product of products) {
    //             try {
    //                 const res = await fetch(`${apiBaseUrl}/getOfferByItemId/${product.ID}`);
    //                 if (res.ok) {
    //                     const data = await res.json();
    //                     prices[product.ID] = data.OfferPrice;
    //                 }
    //             } catch (err) {
    //                 console.error(`Error fetching offer for product ${product.ID}`, err);
    //             }
    //         }
    //         setOfferPrices(prices);
    //     };

    //     if (products.length > 0) {
    //         fetchOfferPrices();
    //     }
    // }, [products]);



    const toggleFilter = () => {
        setShowFilter(!showFilter);
    };

    const closeFilter = () => {
        setShowFilter(!showFilter);
    };


    // Toggle function for 'Need Help'
    const togglePrice = () => {
        setPriceExpanded(!isPriceExpanded);
    };

    const toggleColors = () => {
        setIsColorsExpanded(!isColorsExpanded);
    };

    const toggleSize = () => {
        setIsSizeExpanded(!isSizeExpanded);
    };

    const toggleDress = () => {
        setIsDressExpanded(!isDressExpanded);
    };


    const handleFilterClick = () => {
        setShowFilterMob(true);
    };

    const closeFilterMob = () => {
        setShowFilterMob(false);
    };

    function encodeBase64(text) {
        return btoa(text);
    }

    // Encrypt and Navigate with Base64
    const fullimage = (id, itemName) => {
        navigate(`/fullimage?I=${encodeBase64(String(id))}&N=${encodeBase64(itemName)}`, { state: { id, itemName } });
    };

    // const fullimage = (id, itemName) => {
    //     navigate('/fullimage', { state: { id, itemName } });
    // };



    return (
        <div className='min-h-screen bg-white text-black font-montserrat' onClick={() => setShowDropdown(false)}>
            {isMobile ? <NavbarMob /> : <Navbar />}

            <div className='w-full max-w-[1440px] mx-auto lg:px-12 px-4 py-8 flex flex-col gap-8 lg:mt-[160px] md:mt-[140px] mt-[60px] pb-20'>
                {/* Breadcrumbs */}
                <div className='flex items-center gap-2 text-sm'>
                    <span className='text-gray-400 cursor-pointer hover:text-black transition-colors' onClick={home}>Home</span>
                    <span className='text-gray-300'>/</span>
                    <span className='text-black font-semibold'>{categoryName}</span>
                </div>

                <div className='flex flex-col lg:flex-row gap-10'>
                    {/* Desktop Sidebar Filter (Minimal for now) */}
                    {showFilter && (
                        <aside className='hidden lg:flex flex-col w-[280px] shrink-0 gap-8'>
                            <div className='flex items-center justify-between pb-4 border-b border-gray-100'>
                                <h2 className='text-xl font-bold'>Filters</h2>
                                <button onClick={closeFilter} className='text-gray-400 hover:text-black'>
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" /></svg>
                                </button>
                            </div>

                            {/* Price Filter */}
                            <div className='flex flex-col gap-4'>
                                <div className='flex items-center justify-between cursor-pointer group' onClick={togglePrice}>
                                    <h3 className='font-bold group-hover:text-gray-600 transition-colors'>Price Range</h3>
                                    <svg className={`w-4 h-4 transition-transform duration-300 ${isPriceExpanded ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" /></svg>
                                </div>
                                {isPriceExpanded && (
                                    <div className='flex flex-col gap-6 pt-2'>
                                        <div className='relative h-2 w-full bg-gray-100 rounded-full overflow-hidden'>
                                            <div
                                                className='absolute h-full bg-black'
                                                style={{ left: `${(minPrice / 2000) * 100}%`, right: `${100 - (maxPrice / 2000) * 100}%` }}
                                            />
                                        </div>
                                        <div className='flex items-center justify-between gap-4'>
                                            <div className='flex-1 p-2 bg-gray-50 border border-gray-100 rounded-lg text-center text-sm font-semibold'>₹{minPrice}</div>
                                            <div className='flex-1 p-2 bg-gray-50 border border-gray-100 rounded-lg text-center text-sm font-semibold'>₹{maxPrice}</div>
                                        </div>
                                        <button
                                            onClick={() => { setPriceFilterApplied(true); fetchProductsWithAvailability(); }}
                                            className='w-full py-2 bg-black text-white text-sm font-bold rounded-lg hover:bg-gray-800 transition-all'
                                        >
                                            Apply Price
                                        </button>
                                    </div>
                                )}
                            </div>
                        </aside>
                    )}

                    {/* Product Grid Area */}
                    <main className='flex-1'>
                        {loading || !hasLoadedOnce ? (
                            <div className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-5 gap-y-10'>
                                {[...Array(4)].map((_, i) => (
                                    <div key={i} className='flex flex-col gap-4 animate-pulse' style={{ opacity: 1 - i * 0.25 }}>
                                        <div className='aspect-[3/4] bg-gray-100 rounded-2xl' />
                                        <div className='h-4 w-3/4 bg-gray-100 rounded-full' />
                                        <div className='h-4 w-1/4 bg-gray-100 rounded-full' />
                                    </div>
                                ))}
                            </div>
                        ) : products.length === 0 ? (
                            <div className='flex flex-col items-center justify-center py-20 text-center gap-4'>
                                <div className='w-16 h-16 bg-gray-50 rounded-full flex items-center justify-center'>
                                    <svg className="w-8 h-8 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>
                                </div>
                                <p className='text-gray-500 font-medium'>No products found.</p>
                                <button onClick={() => navigate('/')} className='text-sm font-bold border-b-2 border-black pb-1'>Back to Home</button>
                            </div>
                        ) : (
                            <div className='flex flex-col gap-12'>
                                <div className={`grid gap-x-5 gap-y-10 ${showFilter ? "grid-cols-2 md:grid-cols-2 lg:grid-cols-3" : "grid-cols-2 md:grid-cols-3 lg:grid-cols-4"}`}>
                                    {products.map((product) => {
                                        const isVisible = visibleProducts.includes(product.ID);
                                        const isInWishlist = wishlistItems.some(item => item.ID === product.ID);

                                        return (
                                            <div key={product.ID}
                                                className={`group flex flex-col gap-3 cursor-pointer transition-all duration-400 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                                                onClick={() => fullimage(product.ID, product.ItemName)}
                                            >
                                                <div className='relative aspect-[3/4] rounded-2xl bg-[#F5F5F7] overflow-hidden'>
                                                    <img
                                                        src={`${apiLocalUrl}/uploads/${product.displayFirst}.webp`}
                                                        alt={product.ItemName}
                                                        className='w-full h-full object-cover transition-transform duration-400 group-hover:scale-105'
                                                        loading="lazy"
                                                        onError={(e) => { e.target.src = product1; }}
                                                    />
                                                    <button
                                                        className={`absolute top-4 right-4 w-10 h-10 rounded-full shadow-sm flex items-center justify-center transition-all ${isInWishlist ? 'bg-black text-white' : 'bg-white/80 backdrop-blur-sm text-black hover:bg-white'}`}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            isInWishlist ? removeFromWishlist(product.ID) : addToWishlist(product);
                                                        }}
                                                    >
                                                        <img src={isInWishlist ? filledHeart : heart} alt="wishlist" className={`w-5 h-5 ${isInWishlist ? 'brightness-0 invert' : ''}`} />
                                                    </button>
                                                </div>
                                                <div className='flex flex-col gap-1 font-montserrat'>
                                                    <PromotionTags product={product} />
                                                    <h3 className='text-left text-sm font-semibold truncate group-hover:text-red-600 underline-offset-4'>{product.ItemName}</h3>
                                                    <div className='flex items-center gap-2'>
                                                        <span className='font-bold'>₹{product.MRP}</span>
                                                        {/* {product.MOP > 0 && product.MOP < product.MRP && (
                                                            <span className='text-xs text-gray-400 line-through'>₹{product.MOP}</span>
                                                        )} */}
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>

                                {isLoadingMore && (
                                    <div className='flex justify-center py-8'>
                                        <div className='w-8 h-8 border-4 border-black border-t-transparent rounded-full animate-spin' />
                                    </div>
                                )}

                                {!isLoadingMore && hasMore && (
                                    <div className='flex justify-center py-8'>
                                        <button
                                            onClick={loadMoreProducts}
                                            className='px-8 py-3 bg-black text-white text-sm font-bold rounded-full hover:bg-gray-800 transition-all transform hover:scale-105 shadow-lg'
                                        >
                                            Load More Products
                                        </button>
                                    </div>
                                )}

                                {/* {!hasMore && (
                                    <div className='text-center py-10 border-t border-gray-100'>
                                        <p className='text-gray-400 text-sm italic'>End of collection</p>
                                    </div>
                                )} */}
                            </div>
                        )}
                    </main>
                </div>
            </div>

            {showFilterMob && <Filter closeFilterMob={closeFilterMob} />}
            {isTab ? <FooterMob /> : <Footer />}
        </div>
    );
}

export default SubCatProducts;
